import { render, staticRenderFns } from "./RegularLegCard.vue?vue&type=template&id=d1755a50"
import script from "./RegularLegCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularLegCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports